@reference "~/styles.css";

@layer components {
	.highlightTimestampCursor {
		@apply select-none;
	}
}
